export default "__VITE_ASSET__91Z3LkAa__"